export default __webpack_public_path__ + "static/media/img-0413-austria-premium-face.90c90d21.png";